import { render, staticRenderFns } from "./Index-nueva-compra.vue?vue&type=template&id=1fc14d87"
import script from "./Index-nueva-compra.vue?vue&type=script&lang=js"
export * from "./Index-nueva-compra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports